var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineVersionLogoComplaint(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    contentScriptType: "text/ecmascript",
    width: 24,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    zoomAndPan: "magnify",
    contentStyleType: "text/css",
    viewBox: "0 0 24 24",
    height: 24,
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeMiterlimit: 10,
    stroke: "#3e3832",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 14.5v-2.812M7.5 11.703v2.797l-5.009 1.789c-1.194.427-1.991 1.558-1.991 2.825v2.386h11"
  }), /*#__PURE__*/React.createElement("ellipse", {
    rx: 5,
    ry: 6,
    cx: 9.988,
    cy: 6.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.953 5.969l-.465.031c-1.703.328-2.797-.289-3.734-1.93-.563 1.078-2.321 1.93-3.766 1.93-.71 0-1.324-.146-1.936-.467"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M20.268 16.732l-3.536 3.536M20.268 20.268l-3.536-3.536"
  }), /*#__PURE__*/React.createElement("circle", {
    r: 5,
    cx: 18.5,
    cy: 18.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineVersionLogoComplaint);
export default __webpack_public_path__ + "static/media/line-version-logo-complaint.95601e841f5676680aacaf00e4dbb301.svg";
export { ForwardRef as ReactComponent };